import { getProductPictureFromArticleColor } from '@/models/article';
import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';
import { useMultiStepCreationContext } from '@/routes/Requests/contexts/MultiStepCreationContext';
import { useRequestContext } from '@/routes/Requests/contexts/RequestContext';
import useViewPort from '@/utils/useViewport';

export const useNewArticleInfoSidePanelSections = () => {
  const { view, article } = useArticleContext();
  const { isFirstStep, isLastStep } = useMultiStepCreationContext();
  const { isMobile } = useViewPort();
  const {
    view: { workshopPrice, organizationPrice },
  } = useRequestContext();

  const showProductName = !isFirstStep || isMobile;
  const showPrices = isLastStep && (organizationPrice.shown || workshopPrice.shown);
  const showProductPicture = isFirstStep && !!getProductPictureFromArticleColor({ article });
  const showInformation = !isFirstStep;
  const showHistory = view.details.serialNumber.history.shown;
  const showWarranty = view.warranty.shown && view.warranty.type === 'warranty' && !isFirstStep;
  const showAuthenticity =
    view.warranty.shown && view.warranty.type === 'authenticity' && !isFirstStep;

  const isOrganizationPriceNegative =
    !!article.snapshot.organizationPrice?.amountPerCurrency?.[0]?.amount &&
    article.snapshot.organizationPrice.amountPerCurrency[0].amount < 0;
  const allowDiscount =
    view.prices.discount.client.shown && showPrices && !isOrganizationPriceNegative;

  const newArticleInfoSidePanelSections = {
    showPrices,
    showProductPicture,
    showInformation,
    showHistory,
    showWarranty,
    showAuthenticity,
  };

  const showSidePanel = Object.values(newArticleInfoSidePanelSections).some(
    (showSection) => showSection === true
  );

  return {
    ...newArticleInfoSidePanelSections,
    showSidePanel,
    showProductName,
    allowDiscount,
  };
};
